<template>
  <div class="content">
    <md-dialog :md-active.sync="showDialog">
      <md-dialog-title>{{ $t('edit_user_dialog_title') }}</md-dialog-title>

      <md-dialog-content>
        <form>
          <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-20">
              <md-field>
                <label for="addressForm">{{ $t('table_header_address_form') }}</label>
                <md-select v-model="addressForm" name="addressForm" id="addressForm">
                  <md-option value="Herr">{{ $t('address_form_male') }}</md-option>
                  <md-option value="Frau">{{ $t('address_form_female') }}</md-option>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>{{ $t('table_header_surname') }}</label>
                <md-input v-model="firstName" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-40">
              <md-field>
                <label>{{ $t('table_header_lastname') }}</label>
                <md-input v-model="lastName" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-33">
              <md-field>
                <label>{{ $t('table_header_title') }}</label>
                <md-input v-model="title" type="text"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-33">
              <md-field>
                <label>{{ $t('table_header_email') }}</label>
                <md-input v-model="email" type="email"></md-input>
              </md-field>
            </div>
            <div class="md-layout-item md-small-size-100 md-size-33">
              <md-field>
                <label>{{ $t('table_header_phone') }}</label>
                <md-input v-model="phone" type="text"></md-input>
              </md-field>
            </div>
          </div>
        </form>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary" @click="commitChanges();">Speichern</md-button>
      </md-dialog-actions>
    </md-dialog>
    <div class="md-layout">
      <div
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <p-s-table
                tableHeaderColor="purple"
                v-bind:title="$t('user_settings')"
                v-bind:subTitle="$t('user_settings_subtitle')"
                height="175"
                v-bind:data="this.userData"
                v-bind:dict="this.userDict"
        ></p-s-table>
      </div>
      <md-button class="md-primary" style="margin-left: auto; margin-right: 20px;" v-on:click="openEditModal()">{{ $t('edit_button') }}</md-button>
    </div>
  </div>
</template>

<script>
import { PSTable } from "@/components";
import store from '@/store/index.js';
import api from "@/api/api";

export default {
  name: "UserProfile",
  components: {
    PSTable
  },
  data () {
    return {
      userData: [],
      userDict: [
        {key: 'id', label: 'User ID', type: 'string'},
        {key: 'addressForm', label: 'table_header_address_form', type: 'string'},
        {key: 'title', label: 'table_header_title', type: 'string'},
        {key: 'firstName', label: 'table_header_surname', type: 'string'},
        {key: 'lastName', label: 'table_header_lastname', type: 'string'},
        {key: 'phone', label: 'table_header_phone', type: 'string'},
        {key: 'mail', label: 'table_header_email', type: 'string'},
        {key: 'role', label: 'table_header_role', type: 'string'},
      ],
      showDialog: false,
      addressForm: "",
      firstName: "",
      lastName: "",
      title: "",
      phone: "",
      email: ""
    }
  },
  created() {
    this.pullData();
  },
  methods: {
    openEditModal() {
      this.showDialog = true;
    },
    pullData() {
      api.getUserInfo().then((result) => {
        this.userData = result.data;

        this.addressForm = this.userData[0].addressForm;
        this.firstName = this.userData[0].firstName;
        this.lastName = this.userData[0].lastName;
        this.title = this.userData[0].title;
        this.phone = this.userData[0].phone;
        this.email = this.userData[0].mail;
        this.showDialog = false;
      });
    },
    commitChanges() {
      api.putUserInfo(this.userData[0].id, this.addressForm, this.firstName, this.lastName, this.title, this.phone, this.email).then(() => {
        this.pullData();
      });
    }
  }
};
</script>

<style scoped>

</style>
